import React, { Component } from 'react'
import { Link } from 'react-router'
import { observer, inject } from 'mobx-react'

@inject('auth')
@observer
class MainMenu extends Component {

  render() {
    const { admin, migration_status } = this.props.auth.user
    const undecided = migration_status === 'migrated_undecided'
    return (
      <div className="menu secondary main">
        <Link to="/websites" activeClassName="active">Websites</Link>
        { admin ? <Link to="/billing" activeClassName="active">Billing</Link> : '' }
        { admin ? <Link to="/users" activeClassName="active">Users</Link> : '' }
        { admin ? <Link to="/integrations" activeClassName="active">Integrations</Link> : ''}
        {admin && undecided ? <Link to="/confirm-plan" activeClassName="active">Confirm Your Plan</Link> : '' }
        <a href="https://support.showcaseidx.com/hc/en-us" target="_blank">Support Center</a>
      </div>
    )
  }
}

export default MainMenu



// WEBPACK FOOTER //
// client/components/navigation/MenuMain.js